document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-subscription-toggle]').forEach(function (toggle) {
    const collectionBody = toggle.closest('.collection-body');
    if (!collectionBody) return;

    const applyState = function (isActive) {
      toggle.classList.toggle('is-active', isActive);
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      collectionBody.classList.toggle('subscription-disabled', !isActive);

      collectionBody.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
        if (!input.dataset.originalValue) {
          input.dataset.originalValue = input.value || '';
        }

        input.value = isActive ? input.dataset.originalValue : '';
        input.disabled = !isActive;
      });
    };

    applyState(toggle.classList.contains('is-active'));

    toggle.addEventListener('click', function () {
      applyState(!toggle.classList.contains('is-active'));
    });

    // Filtering/sorting replaces the grid markup, so re-apply the current state to the new cards.
    const grid = collectionBody.querySelector('#ProductGridContainer');
    if (grid) {
      new MutationObserver(function () {
        applyState(toggle.classList.contains('is-active'));
      }).observe(grid, { childList: true, subtree: true });
    }
  });
});
